module.exports = __webpack_public_path__ + "static/media/bt_left.8e72f229.svg";